// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../styles/helpers.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__infoStripContainer___Vk5BG {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.styles__infoStripRed___Y2D2x {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
}

.styles__infoStripMargin___XL0v5 {
  margin-top: 24px;
}

.styles__infoStrip___PwfyV {
  width: calc(99.9% * 67/100 - (30px - 30px * 67/100));
  height: 36px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  margin-bottom: 12px;
}

.styles__infoStrip___PwfyV:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__infoStrip___PwfyV:last-child {
  margin-right: 0;
}

.styles__infoStrip___PwfyV:nth-child(100n) {
  margin-right: 0;
  float: right;
}

.styles__infoStrip___PwfyV:nth-child(100n + 1) {
  clear: both;
}
.styles__mb0___EgrHm {
  margin-bottom: 0 !important;
}

.styles__drfStrip___UjGv4 {
  display: flex;
  flex-direction: column;
}
.styles__drfBody___sGH9p {
  width: calc(99.9% * 67/100 - (30px - 30px * 67/100));
  padding: 24px 0 24px 0;
  position: relative;
}
.styles__drfBody___sGH9p:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}
.styles__drfBody___sGH9p:last-child {
  margin-right: 0;
}
.styles__drfBody___sGH9p:nth-child(100n) {
  margin-right: 0;
  float: right;
}
.styles__drfBody___sGH9p:nth-child(100n + 1) {
  clear: both;
}
.styles__templateId___Xj_Mg {
  position: absolute;
  font-size: 15px;
  top: 12px;
  right: 12px;
}
.styles__templateId___Xj_Mg span {
    font-weight: 800;
  }

.styles__pendingInfoStrip___XmWzg {
  width: calc(99.9% * 66.8/100 - (30px - 30px * 66.8/100));
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
  height: 36px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  margin-top: 12px;
}

.styles__pendingInfoStrip___XmWzg:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__pendingInfoStrip___XmWzg:last-child {
  margin-right: 0;
}

.styles__pendingInfoStrip___XmWzg:nth-child(100n) {
  margin-right: 0;
  float: right;
}

.styles__pendingInfoStrip___XmWzg:nth-child(100n + 1) {
  clear: both;
}

.styles__infoStripTitle___zJuZb {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  color: white;
  font-weight: 600;
  font-size: 1.125rem;
  width: 100%;
}
.styles__drfTitle___suklf {
  display: flex;
  color: white;
  font-weight: 600;
  font-size: 1.125rem;
  width: 100%;
  text-transform: uppercase;
}

.styles__squareBox___sSdVN {
  content: '';
  display: inline-block;
  width: 16px;
  height: 16px;
  background-color: white;
}
.styles__drfSubheader___rvyig {
  font-weight: 600;
  margin-right: 4px;
}

.styles__infoStripSecondary___tWO2k {
  width: calc(99.9% * 66.4/100 - (30px - 30px * 66.4/100));
  border-color: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]};
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]};
  border-radius: 3px;
  padding: 18px;
}

.styles__infoStripSecondary___tWO2k:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__infoStripSecondary___tWO2k:last-child {
  margin-right: 0;
}

.styles__infoStripSecondary___tWO2k:nth-child(100n) {
  margin-right: 0;
  float: right;
}

.styles__infoStripSecondary___tWO2k:nth-child(100n + 1) {
  clear: both;
}

.styles__infoStripSecondary___tWO2k .styles__infoStripSecondaryTitle___ZlKSI {
    color: #31333f;
    font-weight: 600;
  }

.styles__infoStripSecondary___tWO2k h1 {
    font-size: 12px;
    color: gray;
    font-weight: 500;
    margin-top: 12px;
    opacity: 0.8;
  }

.styles__infoStripSecondary___tWO2k p {
    font-size: 12px;
    color: gray;
    font-weight: 600;
    margin-top: 12px;
    margin-left: 28px;
  }

.styles__submitButtons___xGGvb {
  width: calc(99.9% * 66.4/100 - (30px - 30px * 66.4/100));
  margin-top: 12px;
  justify-content: right;
}

.styles__submitButtons___xGGvb:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__submitButtons___xGGvb:last-child {
  margin-right: 0;
}

.styles__submitButtons___xGGvb:nth-child(100n) {
  margin-right: 0;
  float: right;
}

.styles__submitButtons___xGGvb:nth-child(100n + 1) {
  clear: both;
}

.styles__buttonDanger___Q4CtH {
  cursor: pointer;
}

.styles__pencilIcon___GvhhB {
  cursor: pointer;
}

.styles__expeditedSection___qQdMj {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.styles__daysInPending___YatHb {
  font-size: 0.75rem;
}

.styles__pendingRight___Wzg6W {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  gap: 12px;
  color: white;
  font-weight: 600;
}

.styles__iconContainer___xlzZ0 {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: 8px;
  right: 12px;
  gap: 4px;
}
`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/Distributions/components/HeaderStrip/styles.css"],"names":[],"mappings":"AAIA;EAEE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,8DAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oDAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;AACrB;;AATA;EACE,WAAmB;EAAnB,kBAAmB;EAAnB,WAAmB;AAQrB;;AATA;EACE,eAAmB;AAQrB;;AATA;EACE,eAAmB;EAAnB,YAAmB;AAQrB;;AATA;EACE,WAAmB;AAQrB;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,oDAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;AAJA;EACE,WAAmB;EAAnB,kBAAmB;EAAnB,WAAmB;AAGrB;AAJA;EACE,eAAmB;AAGrB;AAJA;EACE,eAAmB;EAAnB,YAAmB;AAGrB;AAJA;EACE,WAAmB;AAGrB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,WAAW;AAIb;AAHE;IACE,gBAAgB;EAClB;;AAGF;EACE,wDAAqB;EACrB,8DAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAVA;EACE,WAAqB;EAArB,kBAAqB;EAArB,WAAqB;AASvB;;AAVA;EACE,eAAqB;AASvB;;AAVA;EACE,eAAqB;EAArB,YAAqB;AASvB;;AAVA;EACE,WAAqB;AASvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,wDAAqB;EACrB,oEAA8B;EAC9B,8DAAwB;EACxB,kBAAkB;EAClB,aAAa;AAsBf;;AA3BA;EACE,WAAqB;EAArB,kBAAqB;EAArB,WAAqB;AA0BvB;;AA3BA;EACE,eAAqB;AA0BvB;;AA3BA;EACE,eAAqB;EAArB,YAAqB;AA0BvB;;AA3BA;EACE,WAAqB;AA0BvB;;AApBE;IACE,cAAc;IACd,gBAAgB;EAClB;;AAEA;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;EACd;;AAEA;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;EACnB;;AAGF;EACE,wDAAqB;EACrB,gBAAgB;EAEhB,sBAAsB;AACxB;;AALA;EACE,WAAqB;EAArB,kBAAqB;EAArB,WAAqB;AAIvB;;AALA;EACE,eAAqB;AAIvB;;AALA;EACE,eAAqB;EAArB,YAAqB;AAIvB;;AALA;EACE,WAAqB;AAIvB;;AAEA;EAEE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,QAAQ;AACV","sourcesContent":["@value helpers: \"styles/helpers.css\";\n@value colors: \"styles/colors.css\";\n@value gtRed, gtGray, gtGray, gtGreen, gtPurpleDark, gtPurpleLight from colors;\n\n.infoStripContainer {\n  composes: content-container from helpers;\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n\n.infoStripRed {\n  background-color: gtRed;\n}\n\n.infoStripMargin {\n  margin-top: 24px;\n}\n\n.infoStrip {\n  lost-column: 67/100;\n  height: 36px;\n  border-radius: 3px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 12px;\n  margin-bottom: 12px;\n}\n.mb0 {\n  margin-bottom: 0 !important;\n}\n\n.drfStrip {\n  display: flex;\n  flex-direction: column;\n}\n.drfBody {\n  lost-column: 67/100;\n  padding: 24px 0 24px 0;\n  position: relative;\n}\n.templateId {\n  position: absolute;\n  font-size: 15px;\n  top: 12px;\n  right: 12px;\n  span {\n    font-weight: 800;\n  }\n}\n\n.pendingInfoStrip {\n  lost-column: 66.8/100;\n  background-color: gtGreen;\n  height: 36px;\n  border-radius: 3px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 12px;\n  margin-top: 12px;\n}\n\n.infoStripTitle {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  color: white;\n  font-weight: 600;\n  font-size: 1.125rem;\n  width: 100%;\n}\n.drfTitle {\n  display: flex;\n  color: white;\n  font-weight: 600;\n  font-size: 1.125rem;\n  width: 100%;\n  text-transform: uppercase;\n}\n\n.squareBox {\n  content: '';\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  background-color: white;\n}\n.drfSubheader {\n  font-weight: 600;\n  margin-right: 4px;\n}\n\n.infoStripSecondary {\n  lost-column: 66.4/100;\n  border-color: 1px solid gtGray;\n  background-color: gtGray;\n  border-radius: 3px;\n  padding: 18px;\n\n  .infoStripSecondaryTitle {\n    color: #31333f;\n    font-weight: 600;\n  }\n\n  h1 {\n    font-size: 12px;\n    color: gray;\n    font-weight: 500;\n    margin-top: 12px;\n    opacity: 0.8;\n  }\n\n  p {\n    font-size: 12px;\n    color: gray;\n    font-weight: 600;\n    margin-top: 12px;\n    margin-left: 28px;\n  }\n}\n\n.submitButtons {\n  lost-column: 66.4/100;\n  margin-top: 12px;\n  composes: buttons from helpers;\n  justify-content: right;\n}\n\n.buttonDanger {\n  composes: buttonDanger from helpers;\n  cursor: pointer;\n}\n\n.pencilIcon {\n  cursor: pointer;\n}\n\n.expeditedSection {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.daysInPending {\n  font-size: 0.75rem;\n}\n\n.pendingRight {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  width: 100%;\n  gap: 12px;\n  color: white;\n  font-weight: 600;\n}\n\n.iconContainer {\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  bottom: 8px;\n  right: 12px;\n  gap: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `"styles/helpers.css"`,
	"colors": `"styles/colors.css"`,
	"gtRed": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]}`,
	"gtGray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]}`,
	"gtGreen": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]}`,
	"gtPurpleDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtPurpleDark"]}`,
	"gtPurpleLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtPurpleLight"]}`,
	"infoStripContainer": `styles__infoStripContainer___Vk5BG ${___CSS_LOADER_ICSS_IMPORT_1___.locals["content-container"]}`,
	"infoStripRed": `styles__infoStripRed___Y2D2x`,
	"infoStripMargin": `styles__infoStripMargin___XL0v5`,
	"infoStrip": `styles__infoStrip___PwfyV`,
	"mb0": `styles__mb0___EgrHm`,
	"drfStrip": `styles__drfStrip___UjGv4`,
	"drfBody": `styles__drfBody___sGH9p`,
	"templateId": `styles__templateId___Xj_Mg`,
	"pendingInfoStrip": `styles__pendingInfoStrip___XmWzg`,
	"infoStripTitle": `styles__infoStripTitle___zJuZb`,
	"drfTitle": `styles__drfTitle___suklf`,
	"squareBox": `styles__squareBox___sSdVN`,
	"drfSubheader": `styles__drfSubheader___rvyig`,
	"infoStripSecondary": `styles__infoStripSecondary___tWO2k`,
	"infoStripSecondaryTitle": `styles__infoStripSecondaryTitle___ZlKSI`,
	"submitButtons": `styles__submitButtons___xGGvb ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttons"]}`,
	"buttonDanger": `styles__buttonDanger___Q4CtH ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttonDanger"]}`,
	"pencilIcon": `styles__pencilIcon___GvhhB`,
	"expeditedSection": `styles__expeditedSection___qQdMj`,
	"daysInPending": `styles__daysInPending___YatHb`,
	"pendingRight": `styles__pendingRight___Wzg6W`,
	"iconContainer": `styles__iconContainer___xlzZ0`
};
export default ___CSS_LOADER_EXPORT___;
